/** Matrix frontend serves assets by id via `/?a={assetId}` on the site origin. */
const MATRIX_ASSET_ID = /^\d+$/;

/**
 * Resolve Funnelback image metadata to a browser-ready `img` src.
 * Numeric values are treated as Matrix asset ids (`/?a=292118`).
 * Full URLs and site-relative paths are returned unchanged.
 */
export function resolveResultImageUrl(raw: string): string {
  const value = raw.trim();
  if (!value) {
    return '';
  }
  if (MATRIX_ASSET_ID.test(value)) {
    return `/?a=${value}`;
  }
  return value;
}
